import { gql } from "@apollo/client";

export const UPDATE_DATOS_GENERALES_RI = gql`
    mutation updateDatosGeneralesRI(
        $screen: Int!,
        $input: AddDatosGeneralesInput!,
         ){
            updateDatosGeneralesRI(
            screen: $screen
            input: $input
        ) {
            idPaciente
        }
    }
`;